import React from 'react'
import { BrowserRouter as Router, Switch, useRouteMatch } from 'react-router-dom'
import EpicMenu from '../../componentes/Menus/EpicMenu';
import Menu from '../../componentes/Menus/Herramientas';
import Inventory from './Inventario/Inventario'
import Empleados from './Inventario/Empleados'
import Compras from './Compra/Compra'
import Catalogos from './Registro/Registro'
import PrivateRoute from '../../PrivateRoute'
import OrdenCompra from './OrdenCompra'
//import '../../componentes/Menus//Menu.css';

const InventoryRoutes = () => {
    let { path, url } = useRouteMatch()
    console.log(url)
    return (
    <>
    <div className='header'>
        <EpicMenu />
        <div className='inline'>Herramientas</div>
    </div>
    <Router>
    <div className='body'>
        <Menu url={url} />
        <section>
            <Switch>
                <PrivateRoute roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']} exact 
                    path={path} component={Inventory} />
                <PrivateRoute roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']} exact 
                    path={`${path}/Empleados`} component={Empleados} />
                <PrivateRoute roles={['productPurchase']} 
                    path={`${path}/Compras`} component={Compras} />
                <PrivateRoute roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']} 
                    path={`${path}/OrdenCompra`} component={OrdenCompra} />
                <PrivateRoute roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']} 
                    path={`${path}/Catalogos`} component={Catalogos} />
            </Switch>
        </section>
    </div>
    <div className="footer" >
        <div className="footer1" >
        </div>
        <div className="footer2" ></div>
    </div>
    </Router>
    </>
    )
}

export default InventoryRoutes